import { SourceIconLookup } from 'component-library-and-tools';
import { DestinationType } from '../types/destination';

const destinationUIDataMapper = {
    [DestinationType.SPLUNK]: {
        label: 'Splunk',
        icon: SourceIconLookup.SPLUNK,
    },
    [DestinationType.SPLUNK_ES]: {
        label: 'Splunk ES',
        icon: SourceIconLookup.SPLUNK_ES,
    },
    [DestinationType.SPLUNK_SOAR]: {
        label: 'Splunk SOAR',
        icon: SourceIconLookup.SPLUNK,
    },
    [DestinationType.ENCLAVE]: {
        label: 'Enclave',
        icon: SourceIconLookup.TRUSTAR,
    },
};

export const getDestinationLabelAndIcon = (
    destinationType: DestinationType
) => {
    const destinationUIData = destinationUIDataMapper[destinationType];

    if (destinationUIData) {
        return destinationUIData;
    } else {
        console.error('Failed to fetch UI Data for ', destinationType);
        return destinationUIDataMapper[DestinationType.ENCLAVE];
    }
};

export const getDestinationLabel = (destinationType: DestinationType) => {
  const destinationUIData = destinationUIDataMapper[destinationType];

  return destinationUIData ? destinationUIData.label : '';
}